export default (setupFn) => {
  // Keep one reference per callback
  let teardownFn
  let hasRunForCurrentPage = false

  const run = () => {
    if (hasRunForCurrentPage) return
    hasRunForCurrentPage = true

    // If setupFn returns a function we treat it as a “teardown”
    teardownFn = setupFn() || (() => {})
  }

  // 1. Turbo visit (fires on initial load and subsequent visits)
  document.addEventListener(`turbo:load`, run)

  // 2. Fallback for non-Turbo or initial load (if Turbo script hasn't fired yet)
  if (document.readyState === `loading`) {
    document.addEventListener(`DOMContentLoaded`, run)
  } else {
    run()
  }

  // 3. When Turbo is about to cache the page, clean up
  document.addEventListener(`turbo:before-cache`, () => {
    if (teardownFn) teardownFn() // remove listeners / classes
    teardownFn = null // release memory
    hasRunForCurrentPage = false
  })
}
